module.exports = __webpack_public_path__ + "af1ff3af4337d5e531e40440e0c6a1c0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/beaker.png
// module id = 2983
// module chunks = 0